module.exports = __webpack_public_path__ + "img/Img23_204422_CfEu-7-1D15.aa86db78.jpg";